import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import { breakpoint, size, width } from '@twistopayments/design-system/styles'

export const header = css`
  width: 100%;
  max-width: ${width.container.compact};
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${size[8]};
  padding: 0 ${size[24]};

  ${breakpoint.up('smMd')} {
    margin: 0 auto;
    max-width: ${width.container.wider};
  }
`

export const title = (theme: Theme) => css`
  color: ${theme.palette.secondary.mainContrast};
  font-weight: 700;
`

export const subtitle = css`
  font-weight: 500;
`
